/**
 * Listing Type Enum
 *
 * Identifies the kind of listing entity a piece of content represents.
 * Uses singleton pattern for instance management.
 *
 * @module enums/listingType
 */

export default class ListingType {
  static instances = {};

  /** A community listing. */
  static get Community() {
    return this.getInstance('community');
  }

  /** A house/floor plan listing. */
  static get HousePlan() {
    return this.getInstance('house-plan');
  }

  /** A housing unit (Quick Move-In / Model home) listing. */
  static get HousingUnit() {
    return this.getInstance('housing-unit');
  }

  /** A sold home listing. */
  static get SoldHome() {
    return this.getInstance('sold-home');
  }

  /** @private */
  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ListingType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return this.name;
  }
}
